/**
 * Shared localStorage key constants for the GDPR-05 / D-37 cookie consent contract.
 *
 * Both the CookieConsentBanner (write-side) and the SettingsPage cookie reset
 * (clear-side) MUST import these constants. Raw string literals are forbidden —
 * a key drift between writer and clearer silently no-ops the
 * withdraw-from-settings path (BL-01 in 02-REVIEW.md).
 *
 * Phase 1 contract (preserved verbatim, do not rename):
 *   COOKIE_CONSENT_KEY      → 'accept' | 'reject'
 *   COOKIE_CONSENT_CATS_KEY → JSON.stringify({ analytics: bool, marketing: bool })
 */
export const COOKIE_CONSENT_KEY = 'cookie-consent';
export const COOKIE_CONSENT_CATS_KEY = 'cookie-consent-cats';

/** Convenience: every key the banner persists. Used by SettingsPage to reset. */
export const COOKIE_CONSENT_KEYS = [
  COOKIE_CONSENT_KEY,
  COOKIE_CONSENT_CATS_KEY,
] as const;
